export enum StatusSolicitacaoAudiencia {
    Nova = 1,
    PendenteDeIntegracao = 2,
    SolicitadosExecutores = 3,
    AudienciaRealizadaAguardandoAta = 4,
    AudienciaRealizadaAtaRecebida = 5,
    Cancelada = 6,
    AguardandoAvaliacaoExecutores = 7,
    AguardandoRealizacaoAudiencia = 8
}